import React, { useRef, useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 


const apiUrl = config.apiUrl;

const CreateThank = ({ onThankCreated }) => {

  const quillRef = useRef(null); // Create a ref
  const [formData, setFormData] = useState({
    topBar: "",
    headline: "",
    subHeadline: "",
    slug: "",
    image: null,
    video: "",
    showImage:"",
    ticketText: "",
    webinarHeadline: "",
    webinarStartsIn: "",
    webinarStartsText: "",
    webinarButtonText: "",
    redirectPage: "",
  });


  const quillModules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };
  
  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
  
    if (type === "checkbox") {
      // For checkboxes, use `checked` instead of `value`
      setFormData((prev) => ({
        ...prev,
        [name]: checked,  // Set the value as true/false based on checked
      }));
    } else if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  


  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      steps: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      // If the key is an image or file, append it as a file
      if (key === "image" && formData[key]) {
        data.append(key, formData[key]);
      } else {
        data.append(key, formData[key] || ""); // Fallback to empty string for optional fields
      }
    });
  
    try {
      await axios.post(`${apiUrl}/thanks`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure the correct content-type is set
        },
      });
      alert("Thank You Page Created Successfully!");
      onThankCreated();
    } catch (err) {
      if (err.response && err.response.data) {
        console.error("Server responded with:", err.response.data);
        setError("An error occurred: " + JSON.stringify(err.response.data)); // Provide the exact server error
      } else {
        setError("An error occurred while creating the Thank You page.");
      }
    }
  };
  

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Thank You Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Top Bar</label>
          <input
            type="text"
            name="topBar"
            value={formData.topBar}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Sub Headline</label>
          <input
            type="text"
            name="subHeadline"
            value={formData.subHeadline}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        {/* <div className="mb-4">
          <label className="block text-gray-700">Important Message</label>
          <textarea
            name="importantMessage"
            value={formData.importantMessage}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div> */}
        <div className="mb-4">
          <label className="block text-gray-700">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="showImage"
              checked={formData.showImage}
              onChange={handleChange}
              className="mr-2"
            />
            শুধুমাত্র ইমেজ দেখান
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Video URL</label>
          <input
            type="text"
            name="video"
            value={formData.video}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        {/* <div className="mb-4">
          <label className="block text-gray-700">Steps</label>
          <ReactQuill
            value={formData.steps || ""} // Ensure Quill gets a valid string
            onChange={handleQuillChange}
            modules={quillModules}
            formats={quillFormats}
            ref={quillRef}
            className="border w-full p-2"
          />
        </div> */}
        <div className="mb-4">
          <label className="block text-gray-700">Ticket Text</label>
          <input
            type="text"
            name="ticketText"
            value={formData.ticketText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Webinar Headline</label>
          <input
            type="text"
            name="webinarHeadline"
            value={formData.webinarHeadline}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Webinar Starts In</label>
          <input
            type="text"
            name="webinarStartsIn"
            value={formData.webinarStartsIn}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Webinar Starts Text</label>
          <input
            type="text"
            name="webinarStartsText"
            value={formData.webinarStartsText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        {/* <div className="mb-4">
          <label className="block text-gray-700">Webinar Paragraph</label>
          <textarea
            name="webinarParagraph"
            value={formData.webinarParagraph}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div> */}
        <div className="mb-4">
          <label className="block text-gray-700">Webinar Button Text</label>
          <input
            type="text"
            name="webinarButtonText"
            value={formData.webinarButtonText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Redirect Page</label>
          <input
            type="text"
            name="redirectPage"
            value={formData.redirectPage}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        {/* <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div> */}

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Thank You Page
        </button>
      </form>
    </div>
  );
};

export default CreateThank;
